export const DOMAIN_ERROR_CODES = {
    EMPTY: 'EMPTY',
    DUPLICATED: 'DUPLICATED',
    INVALID_WILDCARD_DOMAIN: 'INVALID_WILDCARD_DOMAIN',
    INVALID_DOMAIN: 'INVALID_DOMAIN'
};



// WEBPACK FOOTER //
// ./src/constants/manageDomains.js